import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-185271ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cache" }
const _hoisted_2 = { class: "mod_wrap" }
const _hoisted_3 = { class: "mod_c_title" }
const _hoisted_4 = { class: "liveList mod_wrap_tbody" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "liveList_pagination" }

import { SearchOutlined } from '@ant-design/icons-vue';
import { reactive, ref } from 'vue';
import http from '@/api/user';
import { Pagination, Table, Empty, Input } from 'ant-design-vue';
import Crumb from '@/components/Crumb.vue';
import { emptyDataSec } from '@/assets';


export default /*#__PURE__*/_defineComponent({
  __name: 'userList',
  setup(__props) {

const aTable = Table
const aEmpty = Empty
const aPagination = Pagination;
const aInputSearch = Input.Search
const showLoading = ref<boolean>(false);
// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 100, // 总数
  options: ['12', '24', '36', '48', '60'], // 选项
});

const login = (alias: string) => {
  http.getTokenByUserAlias({
    params: {
      alias
    }
  }).then((res) => {
    const userInfo = res.data.data
    const targetUrl = `${window.location.origin}?lighostoken=${userInfo.token}`
    window.open(targetUrl, '_self')
  })
}

const columns = [
  {
    title: '编号ID',
    dataIndex: 'id',
    width: '100px',
    align: 'left',
    ellipsis: true,
  },
  {
    title: '公司名称',
    dataIndex: 'company',
    align: 'center',
    width: '20%',
    ellipsis: true,
  },
  {
    title: '套餐类型',
    dataIndex: 'version_name',
    align: 'center',
    width: '15%',
  },
  {
    title: '套餐时间',
    align: 'center',
    width: '250px',
    slots: {
      customRender: 'range_time',
    },
  },
  {
    title: '注册时间',
    dataIndex: 'created_at',
    align: 'center',
    width: '23%',
  },
  {
    title: '联系人',
    dataIndex: 'name',
    align: 'center',
    width: '23%',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
    align: 'center',
    width: '23%',
  },
  {
    title: '操作',
    align: 'center',
    width: '23%',
    slots: {
      customRender: 'op',
    },
  },

];

const keyword = ref('')

const datafol = reactive<any[]>([])
const getFirstUserList = () => {
  pageConfig.current = 1
  getUserList()
}
const getUserList = () => {
  const query = {
    keywords: keyword.value,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  showLoading.value = true;
  http
    .getUserList({ params: query })
    .then((res) => {
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total > 0 ? res.data.data.total : 10;
      datafol.length = 0
      datafol.push(...res.data.data.data)
      showLoading.value = false;
    })
    .catch((err) => {
      showLoading.value = false;
    });
};
getUserList()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" 用户列表 "),
        _createVNode(_unref(aInputSearch), {
          class: "mod_range_picker_search",
          value: keyword.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          placeholder: "请输入关键字",
          onSearch: getFirstUserList
        }, {
          enterButton: _withCtx(() => [
            _createVNode(_unref(SearchOutlined))
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (datafol.length === 0)
          ? (_openBlock(), _createBlock(_unref(aEmpty), {
              key: 0,
              class: "empty_wrap",
              image: _unref(emptyDataSec),
              description: "页面暂无数据"
            }, null, 8, ["image"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_unref(aTable), {
                loading: showLoading.value,
                columns: columns,
                pagination: false,
                class: "liveList_w",
                "data-source": datafol,
                rowKey: "id"
              }, {
                range_time: _withCtx(({ record }) => [
                  _createTextVNode(_toDisplayString((record.start_at === '永久' || record.end_at === '永久') ? '永久' : `${record.start_at}~${record.end_at}`), 1)
                ]),
                op: _withCtx(({ record }) => [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (login(record.alias)),
                    class: "link"
                  }, "登录到后台", 8, _hoisted_5)
                ]),
                _: 1
              }, 8, ["loading", "data-source"]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(aPagination), {
                  "show-quick-jumper": "",
                  total: pageConfig.totalSize,
                  current: pageConfig.current,
                  "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig.current) = $event)),
                  "page-size": pageConfig.pageSize,
                  "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig.pageSize) = $event)),
                  pageSizeOptions: pageConfig.options,
                  "show-less-items": "",
                  onChange: getUserList,
                  onShowSizeChange: getUserList,
                  "show-size-changer": "",
                  class: "pagination"
                }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
              ])
            ], 64))
      ])
    ])
  ]))
}
}

})